var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchmodal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2867 16.3584L12.4435 10.7789C13.3503 9.65957 13.8408 8.29102 13.8408 6.85156C13.8408 5.12852 13.1365 3.51289 11.863 2.29473C10.5895 1.07656 8.89303 0.40625 7.09079 0.40625C5.28855 0.40625 3.59206 1.07871 2.31856 2.29473C1.04282 3.51074 0.34082 5.12852 0.34082 6.85156C0.34082 8.57246 1.04507 10.1924 2.31856 11.4084C3.59206 12.6266 5.2863 13.2969 7.09079 13.2969C8.59828 13.2969 10.0293 12.8285 11.2015 11.9648L17.0447 17.5422C17.0619 17.5586 17.0822 17.5715 17.1046 17.5804C17.127 17.5893 17.151 17.5938 17.1752 17.5938C17.1995 17.5938 17.2235 17.5893 17.2459 17.5804C17.2683 17.5715 17.2886 17.5586 17.3057 17.5422L18.2867 16.6076C18.3039 16.5913 18.3175 16.5718 18.3268 16.5505C18.336 16.5291 18.3408 16.5062 18.3408 16.483C18.3408 16.4599 18.336 16.4369 18.3268 16.4156C18.3175 16.3942 18.3039 16.3748 18.2867 16.3584V16.3584ZM10.6548 10.2547C9.70078 11.1635 8.43629 11.6641 7.09079 11.6641C5.7453 11.6641 4.4808 11.1635 3.52681 10.2547C2.57506 9.34375 2.05081 8.13633 2.05081 6.85156C2.05081 5.5668 2.57506 4.35723 3.52681 3.44844C4.4808 2.53965 5.7453 2.03906 7.09079 2.03906C8.43629 2.03906 9.70303 2.5375 10.6548 3.44844C11.6065 4.35938 12.1308 5.5668 12.1308 6.85156C12.1308 8.13633 11.6065 9.3459 10.6548 10.2547Z",
    fill: "#037782"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchmodal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/searchmodal.73391ce8ed0b3fec467de1a3a6be9b94.svg";